<template>
    <div class="chat__item" :class="[ chatItem.sender ? 'chat__item--sender' : '',  chatItem.reacted ? 'chat__item--reacted' : '' ]">

      <!-- Avatar -->
      <div v-if="!chatItem.sender" class="chat__item__avatar">
            <!-- TODO: Show img-Tag only if user has profile image -->
            <!--<img src="" alt="">-->
        </div>

        <!-- Content -->
        <div class="chat__item__content">

         	  <!-- Content: Image (Erstmal nicht) -->
            <!--<img class="chat__item__image" src="../assets/whitelabel/header-bg-mobile.png">--->

            <!-- Content: Text -->
          	<div class="chat__item__message">

           		<!-- Title -->
             	<div v-if="chatItem.sender" class="chat__item__message__title">
             		Ich ({{ chatItem.username }})
            		<span>{{ chatItem.time | formatTimeChat }}</span>
            		<div v-on:click="itemClicked" class="chat__item__message__title__actions">
		             	<span></span>
		             	<span></span>
		             	<span></span>
            		</div>
             	</div>
             	<div v-else class="chat__item__message__title">
             		{{ chatItem.username }}
             		<span>{{ chatItem.time | formatTimeChat }}</span>
             		<div v-on:click="itemClicked" class="chat__item__message__title__actions">
      						<span></span>
      						<span></span>
      						<span></span>
          			</div>
             	</div>

              <!-- Optional: Answer -->
              <!--<ChatAnswer username="Stefan Sinns" text="Keine Chance! Du wirst hier nix mehr holen."></ChatAnswer>--> 

             	<!-- Nachricht -->
             	<p>{{ chatItem.text }}</p>

             	<!-- Optional: Reactions -->
             	<div v-if="chatItem.reactions.length > 0" class="chat__item__message__reactions">

              		<!-- Reaction Item -->
              		<div v-for="r in chatItem.reactions" class="chat__item__message__reactions__item">
                     	<span>{{ r }}</span>1
                  </div>

                </div>
          	</div>
        </div>

    </div>
</template>

<script>
  import ChatAnswer from '../../components/chat/ChatAnswer'

	export default {
    name: 'ChatItem',
    components: { ChatAnswer },
    props: {
      chatItem: Object,
    },
  	data () {
			return {}
  	},
  	beforeCreate () {
  	},
  	methods: {
    		itemClicked() {
      		this.$emit('itemClicked', {})
    		}
  	},
  	computed: {}
	}
</script>

<style lang="scss">
  .chat__item {
      display: flex;
      align-items: flex-end;
      margin-bottom: 12px;
      width: calc(100% - 48px);

      /* Styling for Chat Item, which has been sent from active user */
      &--sender {
        flex-direction: row-reverse;
        margin-left: auto;
        width: calc(100% - 80px);
      }

      &--reacted {
        margin-bottom: 20px;
      }

      &__avatar {
        position: relative;
        fles-shrink: 0;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 8px;
        overflow: hidden;
        background: rgba($colorGreyDark, .08);

        &:before {
          position: absolute;
          top: 8px;
          left: 8px;
          width: 16px;
          height: 16px;
          content: url('../../assets/chat/ic_16_user.svg');
          opacity: .48;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &__content {
        display: flex;
        flex-direction: column;
        flex: 1;

        > div, img {
          &:not(:last-child) {
            margin-bottom: 4px;
            border-radius: 8px 8px 4px 4px;

            ~ div { 
              border-radius: 4px 4px 8px 4px;
            }
          }
        }
      }

      &__image {
        border-radius: 8px 8px 8px 4px;
        width: 100%;
        max-height: 250px;
        object-fit: contain;
        background: rgba($colorGreyDark, .12);
        transition: all .2s ease-in-out;

        &:hover {
          cursor: pointer;
          background: rgba($colorGreyDark, .2);
        }
      }

      &__message {
        background: $colorWhite;
        border-radius: 8px 8px 8px 4px;
        padding: 13px 16px 10px;

        .chat__item--sender & {
          background: var(--color-primary);
        }

        &__title {
          display: flex;
          font-size: 14px;
          font-weight: 500;
          color: $colorGreyDark;
          margin-bottom: 8px;

          .chat__item--sender & {
            color: $colorWhite;
          }

          span {
            margin-top: 3px;
            font-size: 11px;
            font-weight: 400;
            opacity: .48;
            margin-left: auto;
          }

          &__actions {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 16px;
            margin: -16px -20px -16px -12px;
            cursor: pointer;

            &:hover {
             span {
              background: $colorGreyDark;

              .chat__item--sender & {
               background: $colorWhite;
         }
             }
            }

            span {
             width: 2.5px;
             height: 2.5px;
             border-radius: 50%;
             background: rgba($colorGreyDark, .32);
             margin: 0 .75px;
          opacity: 1;
             transition: all .2s ease-in-out;

             .chat__item--sender & {
              background: rgba($colorWhite, .48);
        }
            }
          }
        }

        p {
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: $colorGreyDark;

          .chat__item--sender & {
            color: $colorWhite;
          }
        }

        &__reactions {
          margin: 8px 0 -22px;

          &__item {
            display: inline-flex;
            align-items: center;
            background: $colorWhite;
            box-shadow: inset 0 0 0 1px rgba($colorGreyDark, .12), 0 4px 16px rgba($colorGreyDark, 0);
            font-size: 11px;
            line-height: 0;
            font-weight: 500;
            color: $colorGreyDark;
            padding: 13px 12px 11px 6px;
            border-radius: 12px;
            transition: all .2s ease-in-out;

            &:not(:last-child) {
              margin-right: 4px;
            }

            &:hover {
              box-shadow: inset 0 0 0 1px rgba($colorGreyDark, .24), 0 4px 16px rgba($colorGreyDark, .04);
              transform: translateY(-2px);
              cursor: pointer;
            }

            span {
              font-size: 14px;
              margin-right: 6px;
            }
          }
        }
      }
    }
</style>
